/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Input } from '@angular/core';
import { WizardComponent } from './wizard.component';

@Component({
  standalone: false,
  selector: 'gh-wizard-button-bar',
  templateUrl: 'wizard-button-bar.component.html',
})
export class WizardButtonBarComponent {
  @Input() wizard: WizardComponent;
  @Input() finishLabel: string;
}
